import { usePriceFeed } from 'hooks/usePriceFeed'
import { useLvgState } from 'hooks/games/lvg/useLvgState'
import { currencyFormatter } from 'utils'
import { usePriceDirection } from 'hooks/usePriceDirection'
import { LvgGameHeaderStyled } from './LvgGameHeader.styled'
import { LvgAssetsSelector } from 'components/Organisms/LvgAssetsDropDown.js'

export const LvgWsbGameHeader = () => {
  const { activeAsset } = useLvgState()

  const { priceFeed } = usePriceFeed(activeAsset.id)
  const { direction } = usePriceDirection(priceFeed?.price)

  return (
    <LvgGameHeaderStyled>
      <div className='game_header iw'>
        <div className='asset_display'>
          <div className='asset_menu'>
            <div className='select-box'>
              <div className='select-box__current' tabindex='1'>
                <LvgAssetsSelector noSelect />
              </div>
            </div>
          </div>
        </div>

        <div className={`current_price_display ${direction}`}>
          <div className={`price_direction_icon ${direction}`}></div>
          <label>
            {currencyFormatter(priceFeed?.price, {
              noCurrencySign: true,
              decimalDigits: activeAsset.fiatDecimals >= 3 ? activeAsset.fiatDecimals : 3,
              useLongNumber: true,
            })}
          </label>
        </div>
        <div className='volume_display' />
      </div>
    </LvgGameHeaderStyled>
  )
}
